// Module
var code = `<div class="row"> <div class="col-12 col-lg-10 py-3 mx-auto"> <h2 class="text-primary text-center">We have <span class="agent-count"></span> agents in your area!</h2> <div class="row row-cols-1 agent-data"> </div> </div> </div>`;
// Exports
export default code;